<template>
<div   class="container-fluid">
<div>

<spinner v-bind:spinner='spinner'></spinner>


  <div class="row">
  <div class="col">

    <confirm-box v-if="cb.show">
      <template v-slot:header>
      <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body>
        {{cb.msg1}}   
      </template>
        <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
        <button @click="setConfirmBox(),cb.show=false" type="button" class="btn btn-primary">SI</button>
    </template>    
    </confirm-box>
     

     
  <div class="card border-primary">
  <div  class="card-header bg-primary text-white">
    <h4 style="color:white"> <i  class="fas fa-clipboard-list mr-3" aria-hidden="true"></i>RESO A FORNITORE - PACKING LIST</h4>
  </div>  

  <div class="card-body">

  <div class="row ">    
    <div class="col-4">
        <supplier-select v-bind:isActive="cart.length==0" @update="setSupplierId"></supplier-select>
    </div>       
  </div>  
  <p  style="color:red" v-if="supplierId>0" class="text-center "><strong>PRONTO ALLA SCANSIONE</strong></p>
 

  <!-- TBAR -->
  <div class="row">
    <div class="ml-3 grp_button" role="_group" aria-label="First group">
    <div>  
        <!--
        <button   @click="searchProduct()" style="margin-left:30px;background-color:#FFCC66" type="button" class="btn btn-sm mr-2">
            <i class="fas fa-search" aria-hidden="true"></i>
            RICERCA PRODOTTO
        </button>
        --> 
       
        <button :disabled="supplierId==0" ref="search" @click="setSearchModal()"  type="button" class="btn btn-success ml-2 mb-2"  data-toggle="modal" data-target="#staticBackdropProductSearch">    
            <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            RICERCA PRODOTTO
        </button>
        <button ref="search" @click="reset()"  type="button" class="btn btn-secondary ml-2 mb-2">    
            <i class="fas fa-sync mr-2" aria-hidden="true"></i>
            RESET PACKING-LIST
        </button>
        
    </div>
  </div>
 </div>   


  <!-- ROW -->  
  <div class="row">

  <!-- COL2 -->
  <div class="col">


    <!--
    <div v-if="type=='B'">
      <product-search    @update = "dataProductScanner" @close = "type='A'" v-bind:supplierId = "supplierId"></product-search>    
    </div>
  -->

    <product-search :key="refresh" @update="dataProductScanner" @close = "setSearchModal('close')" v-bind:supplierId = "supplierId"></product-search>    


  <div  class="scroll table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table  class="cart table table-hover table-sm mb-0" id="shoppingCart">
  <thead>
    <tr  class="table-active">
      <th>#</th>
      <th></th>  
      <th>EAN</th>
      
      <th>BRAND</th>
      <th>CODICE</th>         
      <th>DESCRIZIONE</th>
      
      <th>COLORE</th>
      <th>MISURA</th>
      <th class="text-right">IMPORTO</th>
      <!--<th class="text-right">TOTALE</th>-->
    
    
    
    </tr>
    </thead>
    <tbody>
    <tr  class="pointer"  :class="`index-${index}`"  v-for="(product,index) in cart" :key="index">
        <td>{{index+1}}</td> 
        <td><a @click="deleteBox(index)"><i style='color:#FF1493;' data-toggle="tooltip" title="Elimina"  class="fa fa-trash" aria-hidden="true"></i></a></td>
         <td>{{product.barcode}}</td>
        
        <td>{{product.brand}}</td>
         <td><strong>{{product.sku}}</strong></td>
        <td>{{product.category}}  -  {{product.season}} {{product.season_year}}
          <div>
            <span><small>{{product.description}}</small></span>
          </div>
        </td>
        
          
                   
        <td ><strong>{{product.color}}</strong></td>
        <td ><strong>{{product.size}}</strong></td>
        <td class="text-right">{{fmt1(product.cost_price)}}</td>
        
       
        
        
     
      </tr> 
      </tbody>  
      <tfoot>
      <tr > 
      <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      <td style="color:green;font-weight: bold;font-size:25px">TOTALI</td>
      
      <td style="color:green;font-weight: bold;font-size:25px" class="text-right">{{total.items}}</td>
      <td style="color:green;font-weight: bold;font-size:25px" class="text-right">{{fmt1(total.total)}}</td>
      </tr>
      </tfoot>  


    </table>
  </div>









  <!-- COL -->
  </div>

 <!-- ROW -->
  </div>

  </div>
  <!-- CARD -->
  </div>

  <!-- COL -->
  </div>

  
  <!-- ROW -->
  </div>


<alert-box  class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


<!--
</div>
</div>
-->


<div class="row float-right mr-3">
 <button  :disabled="total.items==0 || bt_spinner" @click="confirmBox()"  class="btn btn-primary btn-lg mt-2 ">
   <i class="fas fa-check mr-1" aria-hidden="true"></i>
   REGISTRA
   <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
  </button>
</div>
    
<!-- MAIN-->
</div>

<!-- div container -->
</div>

</template>

<script>
import scannerDetection    from '@/scanner';  


import api                 from '@/api'
import alertBox            from '@/components/common/AlertBox.vue'
import spinner             from '@/components/common/Spinner.vue'
import supplierSelect      from '@/components/common/SupplierSelect.vue'
import confirmBox          from '@/components/common/ConfirmBox.vue'
import pushState           from '@/components/mixins/pushState'
import productSearch       from '@/components/backOffice/StockReturnSearchProduct.vue'
import fmt                 from '@/components/mixins/fmt'
import syncStock           from '@/components/mixins/SyncStock.js' 
import { mapGetters }      from 'vuex'


export default {
  
  
  mixins: [pushState,fmt,syncStock],
  components: {alertBox,spinner,supplierSelect,confirmBox,productSearch
  
  },
  data () 
  {
    return {
     
    
     
     bt_spinner    : false, 
     supplierId    : 0,
     spinner       : false,
     cart         : [],
     msg          : {
       title : '',
       body  : '',
       type  : 0
     },
    
     
    
     index        : 0,
     boxType      : '',
     cb           : {
       title   : '',
       msg1    : '',
       show    : false
     },
     
     row           : 0,
     refresh       : 0
     
     



      }
  },




    watch: {
    // 
    cart : function (value) {
      
      
      var isBtn = value.length > 0 ? 1 : 0
      
      this.$store.commit('AUTH_LOGOUT_BTN',isBtn)
      
    }
    },
  computed: 
  {
    ...mapGetters(['storeId','company','logout_btn']) , 

    total : function() {
   
     
      let  total = {items: 0,total : 0}
      this.cart.forEach(item => {

          total.total  += Number(item.cost_price)
          total.items  += 1
          

      })

      return total
    }
   
    
  },

  mounted : function()
  {
      
   

    $(document).scannerDetection(data => 
    {
      onReceive:
      if(this.supplierId==0)
      {
        this.msg.title = "ATTENZIONE "
        this.msg.body  = "Selezionare un fornitore."
        this.msg.type  = 1
        
        

        return
      }

      onComplete:
      if (data.length == 13)
      { 
        
        this.dataProductScanner(data)
      };       
    });
    
  },
  beforeDestroy () {
      $(document).scannerDetection(false);
    },
  created: function() 
  {
    
  
  },

  methods: 
  { 
    
   
    setSearchModal(type)
    {
      if(type=='close')
      {
        $('#StockReturnProductSearch').modal('hide')  
        return
      }

      this.refresh++
     
      this.$nextTick(() => {
        $('#StockReturnProductSearch').modal('show')
      })

      
    },
    setConfirmBox()
    {
      if(this.boxType=='C')
      {
        this.submit()
      }
      else if(this.boxType =='D')
      {
        
        this.deleteRow()
      }
      else
      {
        this.resetCart()
      }
    },

    confirmBox()
    { 
        this.boxType = 'C'
        this.cb.title = 'CONFERMI PACKING LIST ?' 
        this.cb.msg1 = ''

        this.cb.show = true
       
    },  
    setSupplierId(supplierId)
    {
        this.supplierId = supplierId
        this.$refs.search.focus();
        
        
    },  
    async dataProductScanner(barcode)
    {
      
    this.msg.title = ''
    this.spinner  = true
    const sp        = {'sp':'spDataProductByBarcode'}
    
    const data      = {'barcode' : barcode ,'storeId' : this.storeId} 
    const json      = Object.assign(data, sp)
    
    await api.post(json).then(res => {
      
    
      if(res.status==200)
        {
          if(res.data.recordsets[0].length==0)
          {
            this.msg.title = "ATTENZIONE "
            this.msg.body  = "Prodotto inesistente."
            this.msg.type  = 1
            
            
            return
          }
         
          const supplierId = res.data.recordsets[0][0]['supplierId']  
          
          if(supplierId != this.supplierId)
          {
            this.msg.title = "ATTENZIONE  "
            this.msg.body  = "Il prodotto non è del fornitore selezionato."
            this.msg.type  = 1
            

            return
          }
          
          //$('#staticBackdropProductSearch').modal('handleUpdate');
          this.cart.push(res.data.recordsets[0][0])
          let index  = this.cart.length-1                    
          this.$nextTick(function () 
                {          
                  this.scrollToElement(index)
                })                                   
                

        }
        else if(res.status==500)
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res.data
          this.msg.type  = 1

        } 
        else
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res
          this.msg.type  = 1                
          
        } 
    }).catch(err => 
    {
      console.log(err.message)    
    }).finally(() => {
      this.spinner = false
    });
    

        
        
  
    },
    scrollToElement(index) 
    {
      const el = this.$el.getElementsByClassName('index-' + index)[0];
      
      if (el) {
        el.scrollIntoView();
      }
    },
    reset()
    {
      if(this.cart.length>0)
      {
        this.boxType = 'R'
        this.cb.title = 'CONFERMI RESET PICKING LIST ?'
        this.cb.show = true

      }
    },

    groupingData()
    {
          
      let arr = []      
      this.cart.forEach(item=>{
        let index = arr.map((obj) => obj.barcode).indexOf(item.barcode);
        
        if(index==-1)
        {
          arr.push({'barcode':item.barcode,'cost_price':item.cost_price,'qty':1})
        }
        else
        {
          arr[index]['qty']++
        }
        
      })

      return arr  
    },

    async submit()
    {
        
      this.bt_spinner = true
      let data     = {}
      
      data.header  = {}
      data.body    = this.groupingData()
      
      data.header.companyId     = this.company.Id
      data.header.storeId       = this.storeId
      data.header.supplierId    = this.supplierId
  
      const sp                  = {'sp':'spCreateMovementToSupplier'}
     
      const json   = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
          this.msg.title = "Packing List creata."
          this.msg.body  = ""
          this.msg.type  = 0
          
          this.cart      = []    
          const stockMovementId = res.data.recordsets[0][0].stockMovementId                 
          this.syncStock(stockMovementId)  

          }
          else if(res.status==500)
          {
          
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res.data
            this.msg.type  = 1
          } 
          else
          {
            
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res
            this.msg.type  = 1                             
          } 
      }).catch(err => 
      {
        console.log(err.message)    
      }).finally(() => {
        this.bt_spinner = false
      });



    },
  
 
   
    resetCart()
    {
            
      this.cart = []
      
    },
  
    deleteRow()
    {
      this.cart.splice(this.index, 1);      
    },
    deleteBox(index)
    {
      let row = index + 1
      this.boxType = 'D'
      this.cb.title = 'CONFERMI ELIMINAZIONE RIGA : ' + row
      this.index = index 
      this.cb.show = true
      
    },

 

 
}
}
</script>
<style scoped>



.table-wrapper-scroll-y {
  display: block;
}

.table-scrollBar
{
  height     :400px;  
  overflow   :scroll;
  overflow-x : hidden;
  
}

.my-custom-scrollbar {
    position  : relative;
    height    : 500px;
    overflow  : auto;
    }

.pointer:hover
{
  background-color : lightblue(182, 216, 241, 0.972);
  color            : black;
  cursor           : pointer;
}

.cart thead tr:nth-child(1) th
 {
  
    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #5c8fb1;
    color        : white;
 
    
    position   : sticky;
    top        : 0;
    z-index    : 10;

 }

/* tutti gli header */
.table thead th {
  position    : sticky;
  background  : #5c8fb1;
  color       : white;
  z-index     : 10;
}

 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

 


h4,p {

  font-size    : 20px;
}

.pointer
{
  cursor       : pointer;
}
.cart th:first-child
{
  border-radius : 0 0 0 8px;
}
.cart th:last-child
{
  border-radius : 0 8px 0 0;  
}

.modal-footer {  
  justify-content: space-between;  
}

.card-header
{
  height: 45px;
}
</style>